import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageDefects() {
   const ALL_OPTS = { value: 0, label: "-- Select --", isActive: false };
   const DEFECT_MODEL = { id: 0, defect: "", isActive: true };
   const [defect, setDefect] = useState(DEFECT_MODEL);
   const [defectList, setDefectList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "defect", value: ALL_OPTS }
   ]);
   const [editDefect, setEditDefect] = useState("");
   const [newDefect, setNewDefect] = useState("");
   const [origDefect, setOrigDefect] = useState("");
   const [spinDefect, setSpinDefect] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!defect || defect.id === 0)
         return; // defect was reset to initial state

      if (!editDefect || editDefect.length < 1)
         return; // Not editing       

      if (defect.defect === origDefect)
         return; // No change made to defect being edited

      if (defect.defect.length < 3) { // Do we need this?
         toast.error("Defect description must be at least 3 characters");
         return;
      }
      UpdateDefect();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [defect])

   function ActivateDefect() {
      if (!defect || defect.id === 0) {
         toast.error("Please select a defect to activate");
         return;
      }

      setSpinDefect(true);
      api.post(`Production/ActivateDefect/${defect.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Defect activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinDefect(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinDefect(false);
         });
   }

   function DeleteDefect() {
      setSpinDefect(true);
      api.post(`Production/DeleteDefectType/${defect.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Defect type was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinDefect(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinDefect(false);
         });
   }

   function onDefectChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewDefect(""); // Clear any lingering values
      if (newFilterValue.value === 0) {
         setDefect(DEFECT_MODEL);
         setOrigDefect("");
         setEditDefect("");
      }
      else { // Get the defect to be edited
         const d = _.find(defectList, (x) => x.value === newFilterValue.value);
         let changes = Object.assign({}, defect);
         changes.defect = newFilterValue.label;
         changes.isActive = d.isActive;
         changes.id = newFilterValue.value;
         setDefect(changes);
         setOrigDefect(newFilterValue.label);
         setEditDefect(newFilterValue.label);
      }
   }

   function onDefectUpdate() {
      let changes = Object.assign({}, defect);
      changes.defect = editDefect
      setDefect(changes);
   }

   function runQuery() {
      setSpinDefect(true);
      api
         .fetch(`Production/LoadAllDefectTypes`)
         .then((response) => {
            if (response.data.success) {
               const dfList = _.concat([ALL_OPTS],
                  _.map(response.data.defects, (d) => ({
                     value: d.id,
                     label: d.defect,
                     isActive: d.isActive
                  })));
               return { dfList: dfList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ dfList }) => {
            setDefectList(dfList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditDefect("");
            setOrigDefect("");
            setNewDefect("")
            setDefect(DEFECT_MODEL);
            setSpinDefect(false);
         });
   }

   function SaveNewDefect() {
      if (!newDefect || newDefect.length < 1) {
         toast.error("Please provide a defect description");
         return;
      }
      if (newDefect.length < 3) {
         toast.error("Defect description must be at least 3 characters");
         return;
      }
      let payload = DEFECT_MODEL;
      payload.defect = newDefect;
      
      setSpinDefect(true);
      api.post('Production/SaveDefectType', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Defect type created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinDefect(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinDefect(false);
         });
   }

   function UpdateDefect() {
      setSpinDefect(true);
      api.post('Production/SaveDefectType', defect)
         .then((response) => {
            if (response.data.success) {
               toast.success("Defect type updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinDefect(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinDefect(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!defect || defect.id === 0) {
         toast.error("Please select a defect");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editDefect} defect?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteDefect() }},
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinDefect}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {defectList && defectList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Defect:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="defect"
                                             options={defectList}
                                             value={filterHelpers.getValue(filters, "defect")}
                                             onChangeCallback={e => onDefectChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>
               
                     {defect && defect.id > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a defect that has production records attached will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive defects will not show up in production recording scan options.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {defect.id}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {defect.isActive ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Defect:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={editDefect || ""}
                                             onChange={(e) => setEditDefect(e.target.value)}
                                             maxLength="100"
                                          />
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onDefectUpdate()}
                                          >
                                             Update
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       {!defect.isActive && defect.id !== 1 ? (
                                          <td className="transparent-background data-cell">
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => ActivateDefect()}
                                             >
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     <br />
                     <br />
                     <hr/>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                        Add New Defect Type
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="80px">
                                       Defect:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newDefect || ""}
                                          onChange={(e) => setNewDefect(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Defect"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveNewDefect()}
                                       >
                                          Add Defect
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
